module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABWklEQVRYR+2WsUoDQRCGv/91TKEPIGgKEQQLCztBRTGPoT6BpRgQLBRLGxE7YxFbtdDXGZmwkXDuZW+PCwlyW97uznzz78/ciDkvzTk/LUCWAma2DuwDByVPdw4MJA2qPm0uwBlwmgh+I+lwVgAWAnckfU8mMbMl4Mu/SapcWOWDHtjMRgBlCVL7MVWiAGb2Avh7N7ncG91iwMUEaLLsVKwsD6SC1dmfChC84Kb7fTsz2wFugS1Jr8Gcm8ADcCTpfgwSu1/JAxMB/rjezD6AZaAnqR8AToArYChptXA/ar7xmZQCMQBP5AljAH1JvRagVaBV4N8r8Ax454v1gU9JK7NWwJvQBbAh6S10wjXgCdiT5C15tMJ80GwnzPnhNAHwDrik3ZxBM1TvA40PNteSjsvAU/+CKkNoSpRtSY+1AEIlu2ES7qQyFfaHwKWku2n3Fnsgyay41vFWgR9nkCcwNXIx5wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/delete.png
// module id = vmxF
// module chunks = 5